import { render, staticRenderFns } from "./TableCustom.vue?vue&type=template&id=cbbc579e&scoped=true"
import script from "./TableCustom.vue?vue&type=script&lang=ts"
export * from "./TableCustom.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cbbc579e",
  null
  
)

export default component.exports